import { pillSt } from '../theme/tokens';

export default function StatusPill({ color, title, children, style }) {
  return (
    <span title={title} style={{ ...pillSt(color), ...style }}>
      {children}
    </span>
  );
}
